export default "__VITE_ASSET__BhXikOtq__"